import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

export const StyledGrid = styled.div`
  display: flex;
  width: 100%;
  overflow: hidden;
`;

export const StyledGutter = styled.div`
  flex: 0 0 ${({ width }) => width}px;
  background-color: ${COLOR.white};
`;

export const StyledViewport = styled.div`
  position: relative;
  flex: 1 1 auto;
  overflow-x: auto;
  overflow-y: hidden;
`;

export const StyledContent = styled.div`
  position: relative;
  height: 100%;
  width: ${({ contentWidth }) => contentWidth}px;
`;
